<notifier-container></notifier-container>
<div class="fileUploadContainer">
    <div class="header hdr">
        <h5><span class="animateH5">Run LLM</span></h5>
    </div>
    <div class="container-fluid">
        <div class="row mt-2">
            <div class="d-flex justify-content-center">
            <div class="col-3"> <label>Client &nbsp;</label></div>
            <div class="col-3">
               
             <select  class="form-select" (change)="selectClient($event)">
                  <option value="" selected>Select </option> 
               <ng-container *ngIf="clientList.length > 0">
                <option *ngFor="let client of clientList" value="{{client['config_id']}}">{{client['config_name']}}</option>
              </ng-container>
               </select>
               </div>
               </div>
        </div>
        <div class="row mt-4">
            <div class="d-flex justify-content-center">
                  <button class="btn btn-primary" (click)="run_llm('sentiment')">Email Sentiment</button>&nbsp;
                <button class="btn btn-primary" (click)="run_llm('question_answer')">Email QA</button>
            </div>
        </div>
    </div>
</div>    